import { Empty, Segmented } from "antd";
import { GeneralTab } from "./GeneralTab";
import { useState } from "react";
import { MembersTab } from "./MembersTab";
import trans from "../../../../utils";

const ViewTeam = ({ data }) => {
  const [selected, setSelected] = useState("General");

  const renderContent = () => {
    switch (selected) {
      case "General":
        return <GeneralTab data={data} />;
      case "Members":
        return data?.members?.length > 0 ? (
          <MembersTab data={data} />
        ) : (
          <Empty description={trans("No members assigned")} />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Segmented
          options={[
            { label: trans("General"), value: "General" },
            { label: trans("Members"), value: "Members" },
          ]}
          block
          value={selected}
          onChange={setSelected}
        />

        <div style={{ marginTop: 16, flex: 1, overflowY: "auto" }}>
          {renderContent()}
        </div>
      </div>
    </>
  );
};

export default ViewTeam;
